import React from "react";

export default function InnerBanner({title, secttile}) {
    return (
        <section className="banner-start bg-white  flex flex-col justify-center items-center text-center">
            <div className="container mx-auto px-6 lg:px-12 py-40 text-center">

                {/* Heading */}
                <h1 className="text-4xl font-syne md:text-6xl font-bold leading-tight mb-4 ">{title} </h1>

                {/* Description */}
                <p className="text-lg text-gray-700 max-w-2xl mx-auto font-outfit">
                  {secttile}
                </p>
            </div>
        </section>
    );
}
